module.exports = __webpack_public_path__ + "img/article_image_no_image.b565aae.svg";